// extracted by mini-css-extract-plugin
export default {"root":"src-views-common-components-ChromelessLayout-ChromelessLayout__root--R2iVd"};